import { Column } from 'material-table';
import React from 'react';

import { DirectoryData } from './AbmDirectory';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { GridComparatorFn } from '@mui/x-data-grid/models/gridSortModel';
import { GridValueGetterParams } from '@mui/x-data-grid/models/params/gridCellParams';

type AbmDirectoryTableProps = {
  defaultmessage: JSX.Element;
  columns: {
    columns: (Column<any> & {
      disableColumnMenu?: boolean;
      filterable?: boolean;
      sortComparator?: GridComparatorFn<DirectoryData>;
      valueGetter?: (params: GridValueGetterParams<DirectoryData>) => string | number | boolean;
    })[];
  };
  filteredData: DirectoryData[];
  pageSize?: number;
  disableVirtualization?: boolean;
  columnBuffer?: number;
};
export default function (props: AbmDirectoryTableProps) {
  const { columns, filteredData, defaultmessage, pageSize, disableVirtualization, columnBuffer } = props;

  const columnsDataGrid: GridColDef<DirectoryData>[] = columns.columns.map((value) => {
    return {
      headerName: value.title,
      field: value.field,
      width: value.width,
      disableColumnMenu: value.disableColumnMenu,
      filterable: value.filterable,
      sortComparator: value.sortComparator,
      valueGetter: value.valueGetter,
      renderCell: value.render
        ? (rowData) => {
            if (value.render) {
              return value.render(rowData.row, 'row');
            }
            return rowData.row;
          }
        : undefined,
    } as GridColDef<DirectoryData>;
  });
  if (disableVirtualization && columnBuffer) {
    return (
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={filteredData}
          columns={columnsDataGrid}
          getRowId={(row) => row.areaId}
          getRowHeight={() => 'auto'}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: pageSize ? pageSize : 10,
              },
            },
          }}
          disableColumnFilter={true}
          columnBuffer={columnBuffer ? columnBuffer : undefined}
          disableVirtualization={disableVirtualization}
          pageSizeOptions={pageSize ? [pageSize] : [10]}
          disableRowSelectionOnClick
        />
        {filteredData.length === 0 && <div>{defaultmessage}</div>}
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={filteredData}
        columns={columnsDataGrid}
        getRowId={(row) => row.areaId}
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pageSize ? pageSize : 10,
            },
          },
        }}
        disableColumnFilter={true}
        pageSizeOptions={pageSize ? [pageSize] : [10]}
        disableRowSelectionOnClick
      />
      {filteredData.length === 0 && <div>{defaultmessage}</div>}
    </div>
  );
}
